<template>
    <div class="hub-grid">
        <router-link
            v-for="tool in tools"
            :key="tool.path"
            :to="tool.path"
            class="hub-card"
        >
            <span class="hub-card__icon" aria-hidden="true">
                <i class="fa" :class="tool.icon"></i>
            </span>
            <span class="hub-card__body">
                <span class="hub-card__title">{{ tool.title }}</span>
                <span class="hub-card__description">{{ tool.description }}</span>
            </span>
            <i class="fa fa-arrow-right hub-card__arrow" aria-hidden="true"></i>
        </router-link>
    </div>
</template>

<script>
import tools from "./tools";

export default {
    name: "AcademicManagementSubMenu",
    data() {
        return {
            tools
        };
    }
};
</script>

<style scoped>
.hub-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
    gap: 0.85rem;
    padding: 1.25rem 1.5rem 1.5rem;
}

.hub-card {
    display: flex;
    min-width: 0;
    align-items: flex-start;
    gap: 0.8rem;
    padding: 1rem;
    border: 1px solid #e5eaf0;
    border-radius: 0.75rem;
    background: #fff;
    box-shadow: 0 0.25rem 0.75rem rgba(50, 70, 90, 0.05);
    color: inherit;
    text-decoration: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.hub-card:hover,
.hub-card:focus {
    border-color: #bcd4ef;
    box-shadow: 0 0.5rem 1.15rem rgba(24, 80, 184, 0.1);
    color: inherit;
    text-decoration: none;
    transform: translateY(-1px);
}

.hub-card:focus-visible {
    outline: 2px solid #1850b8;
    outline-offset: 2px;
}

.hub-card__icon {
    display: grid;
    flex: 0 0 2.6rem;
    width: 2.6rem;
    height: 2.6rem;
    place-items: center;
    border-radius: 0.7rem;
    background: #eef4ff;
    color: #1850b8;
    font-size: 1rem;
}

.hub-card__body {
    display: grid;
    min-width: 0;
    flex: 1 1 auto;
    gap: 0.2rem;
}

.hub-card__title {
    color: #344767;
    font-size: 0.9rem;
    font-weight: 700;
    line-height: 1.3;
}

.hub-card__description {
    color: #7b8998;
    font-size: 0.76rem;
    line-height: 1.5;
}

.hub-card__arrow {
    margin-top: 0.35rem;
    color: #b3c1d1;
    font-size: 0.75rem;
    transition: color 0.15s ease, transform 0.15s ease;
}

.hub-card:hover .hub-card__arrow {
    color: #1850b8;
    transform: translateX(2px);
}

@media (max-width: 575.98px) {
    .hub-grid {
        grid-template-columns: minmax(0, 1fr);
        padding: 0.85rem;
    }
}
</style>
